import { render, staticRenderFns } from "./supplierdetail.vue?vue&type=template&id=2e898891&"
import script from "./supplierdetail.vue?vue&type=script&lang=js&"
export * from "./supplierdetail.vue?vue&type=script&lang=js&"
import style0 from "./supplierdetail.vue?vue&type=style&index=0&id=2e898891&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports